exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.step-counter[data-v-7ec3282c] {\n  text-align: center;\n}\n.dot[data-v-7ec3282c] {\n  display: inline-block;\n  background-color: #D8D8D8;\n  height: 8px;\n  width: 8px;\n  margin-right: 22px;\n  border-radius: 50%;\n}\n.dot.active[data-v-7ec3282c] {\n  background-color: #000;\n}\n.dot[data-v-7ec3282c]:last-child {\n  margin-right: 0;\n}", ""]);

// exports
